import { createAction, props } from '@ngrx/store';
import { ITerminalUser } from '../../models/user.model';

export const LoadUsersAction = createAction('[UserManagement] Load Users');

export const StoreUsersAction = createAction(
  '[UserManagement] Store Users',
  props<{ users: ITerminalUser[] }>(),
);

export const LoadUsersErrorAction = createAction(
  '[UserManagement] Load Users Error',
  props<{ error: string }>(),
);

export const DeactivateUserAction = createAction(
  '[UserManagement] Deactivate User',
  props<{ user: ITerminalUser }>(),
);

export const DeactivateUserSuccessAction = createAction(
  '[UserManagement] Deactivate User Success',
  props<{ user: ITerminalUser }>(),
);

export const DeactivateUserErrorAction = createAction(
  '[UserManagement] Deactivate User Error',
  props<{ error: string }>(),
);

export const ResendUserInviteAction = createAction(
  '[UserManagement] Resend User Invite',
  props<{ user: ITerminalUser }>(),
);

export const ResendUserInviteSuccessAction = createAction(
  '[UserManagement] Resend User Invite Success',
  props<{ user: ITerminalUser }>(),
);

export const ResendUserInviteErrorAction = createAction(
  '[UserManagement] Resend User Invite Error',
  props<{ error: string }>(),
);

export const AddUserAction = createAction(
  '[UserManagement] Add User',
  props<{ user: ITerminalUser }>(),
);

export const AddUserSuccessAction = createAction(
  '[UserManagement] Add User Success',
  props<{ user: ITerminalUser }>(),
);

export const UpdateUserAction = createAction(
  '[UserManagement] Update User',
  props<{ user: ITerminalUser }>(),
);

export const UpdateUserSuccessAction = createAction(
  '[UserManagement] Update User Success',
  props<{ user: ITerminalUser }>(),
);

export const UserSaveErrorAction = createAction(
  '[UserManagement] Add or Update User Error',
  props<{ error: string }>(),
);
